<template>
  <div class="container">
    <pcPublicHeader />
    <div class="public-content">
      <div class="page-title">去水印</div>
      <div class="content-item">
        <div class="left-item">
          <div class="textarea"><textarea v-model="url" placeholder="请输入抖音（口令或链接）、图集链接"></textarea></div>
          <div class="btn" @click="handleSubmit">
            <van-loading v-if="loading" color="#ffffff" />
            <span v-else>开始去水印</span>
          </div>
        </div>
        <div class="right-item">
          <div v-if="assetsData.list.length > 0 || assetsData.videoUrl" class="assets-container">
            <div class="btn-item">
              <div v-if="assetsData.list.length > 0" class="btn" @click="handleSaveAllImgs"><img src="../../assets/pc-images/download-icon.png" /> 下载全部图片</div>
              <div v-if="assetsData.videoUrl" class="btn" @click="handleCopy(assetsData.videoUrl)"><img src="../../assets/pc-images/copy-white-icon.png" /> 复制无水印链接</div>
              <div v-if="assetsData.videoUrl" class="btn" @click="handleCopy(assetsData.videoImg)"><img src="../../assets/pc-images/copy-white-icon.png" /> 复制封面链接</div>
              <div v-if="assetsData.videoUrl" class="btn" @click="handleCopy(assetsData.title)"><img src="../../assets/pc-images/copy-white-icon.png" /> 复制视频标题</div>
              <div v-if="assetsData.videoUrl" class="btn" @click="handleDownloadAssets(assetsData.videoUrl)"><img src="../../assets/pc-images/download-icon.png" /> 下载</div>
            </div>
            <div v-if="assetsData.list.length > 0" class="img-list-item">
              <div v-for="(item, index) in assetsData.list" :key="index" class="img-item img-cover">
                <img :src="item" />
                <div class="inner-btn-item">
                  <div class="btn" @click="handleCopy(item)"><img src="../../assets/pc-images/copy-white-icon.png" /> 复制链接</div>
                  <div class="btn" @click="handleDownloadAssets(item)"><img src="../../assets/pc-images/download-icon.png" /> 下载</div>
                </div>
              </div>
            </div>
            <div v-if="assetsData.videoUrl" class="video-item">
              <div class="img img-cover"><img :src="assetsData.videoImg" /></div>
            </div>
          </div>
          <div v-else class="empty img-cover">
            <img src="../../assets/pc-images/empty-img.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import pcPublicHeader from '@/components/pcPublicHeader'
import download from 'downloadjs'

export default {
  name: "Watermark",
  components: {
    pcPublicHeader
  },
  data() {
    return {
      url: '',
      loading: false,
      assetsData: {
        all: false, // 全选
        list: [], // 说明是图片
        videoImg: '', // 视频封面
        videoUrl: '', // 视频下载地址
        title: '' // 标题
      },
      selectedList: []
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  filters: {
    
  },
  mounted() {
    
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    async handleGetDouYinMasterUrl(data) {
      var res = this.$API.getDouYinMasterUrl.post({
        Url: data
      })
      return res
    },
    handleSelected(img) {
      const { selectedList } = this
      const list = []
      let has = false
      for (let index = 0; index < selectedList.length; index++) {
        const item = selectedList[index]
        if (item == img) {
          has = true
        } else {
          list.push(item)
        }
      }
      if (!has) {
        list.push(img)
      }
      this.selectedList = list
    },
    handleSelectedAll() {
      const { assetsData } = this
      if (assetsData.all) {
        this.assetsData.all = false
        this.selectedList = []
      } else {
        this.assetsData.all = true
        this.selectedList = [
          ...assetsData.list
        ]
      }
    },
    handleSaveAllImgs() {
      const { selectedList } = this
      if (selectedList.length > 0) {
        for (let index = 0; index < selectedList.length; index++) {
          const item = selectedList[index]
          this.handleDownloadAssets(item)
        }
      }
    },
    handleDownloadAssets(url) {
      download(url)
    },
    async handleSubmit() {
      // 图片
      // const data = JSON.parse("{\"code\":\"200\",\"msg\":\"\\u89e3\\u6790\\u6210\\u529f\",\"data\":{\"url\":null,\"pics\":[\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813c001\\/ocgARiZwzAA9LLn2ABCFAFtmiAbENIfecAZhzo~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=6oq8zCwzLCKo62dIXSTBqoURgrU%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813\\/oEeIBe8MaIku7fOBxWEMBZSlmEOAUQjAXAAvQA~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=3NuykUCBmpyYuJyRzrit%2BAnAMAA%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813\\/oc7EjXBeAIv8BkZxOOoKAOam7AIBQAfeMlWSQA~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=D9R3v7qmSoQTaQU1imt1q3hwSDw%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813\\/o85AIksvAxjBlkaO7egEBe9fdQgFQAXMADAZ8M~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=x5LIwQdQpaTDwez5%2B7CuadVOfHE%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\"],\"photo\":\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813c001\\/ocgARiZwzAA9LLn2ABCFAFtmiAbENIfecAZhzo~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=6oq8zCwzLCKo62dIXSTBqoURgrU%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"images\":[\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813c001\\/ocgARiZwzAA9LLn2ABCFAFtmiAbENIfecAZhzo~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=6oq8zCwzLCKo62dIXSTBqoURgrU%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813\\/oEeIBe8MaIku7fOBxWEMBZSlmEOAUQjAXAAvQA~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=3NuykUCBmpyYuJyRzrit%2BAnAMAA%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813\\/oc7EjXBeAIv8BkZxOOoKAOam7AIBQAfeMlWSQA~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=D9R3v7qmSoQTaQU1imt1q3hwSDw%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813\\/o85AIksvAxjBlkaO7egEBe9fdQgFQAXMADAZ8M~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=x5LIwQdQpaTDwez5%2B7CuadVOfHE%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\"],\"title\":\"\\u4ed7\\u5251\\u8d70\\u5929\\u6daf\\u3002\\u66fe\\u68a6\\u60f3\\u4ed7\\u5251\\u8d70\\u5929\\u6daf\\uff0c\\u770b\\u4e00\\u770b\\u4e16\\u754c\\u7684\\u7e41\\u534e#\\u786c\\u6d3e\\u8d8a\\u91ce #\\u8d8a\\u91ce\\u623f\\u8f66 #\\u623f\\u8f66\\u65c5\\u884c #vanlife #\\u9732\\u8425\\u8f66\\u6539\\u88c5 \\u4fa7\\u989c\\u6740Vs\\u80cc\\u5f71\\u6740\\uff0c\\u4f60\\u6700\\u559c\\u6b22\\u54ea\\u4e00\\u4e2a\\uff1f\",\"cover\":\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813c001\\/ocgARiZwzAA9LLn2ABCFAFtmiAbENIfecAZhzo~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=6oq8zCwzLCKo62dIXSTBqoURgrU%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\",\"bigFile\":false,\"download_image\":\"https:\\/\\/p3-pc-sign.douyinpic.com\\/tos-cn-i-0813c001\\/ocgARiZwzAA9LLn2ABCFAFtmiAbENIfecAZhzo~tplv-dy-aweme-images-v2:3000:3000:q75.jpeg?x-expires=1735462800&x-signature=6oq8zCwzLCKo62dIXSTBqoURgrU%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=image&biz_tag=aweme_images&l=20241129174807C64C58B1BCDCC60514C2\"}}")
      // 视频
      // const data = JSON.parse("{\"code\":\"200\",\"msg\":\"\\u89e3\\u6790\\u6210\\u529f\",\"data\":{\"title\":\"\\u5929\\u51b7\\u4e86\\u5927\\u5bb6\\u8bb0\\u5f97\\u6dfb\\u8863\\u5594\\uff5e #\\u4e0d\\u503c\\u5f97\",\"url\":\"https:\\/\\/v26-default.365yg.com\\/d01a8f8a6f30ed0aef6b43242492b361\\/67499a14\\/video\\/tos\\/cn\\/tos-cn-ve-15\\/o4eEQQefAAFhIkH8Z2ippziTe73YIBPveUEvCf\\/?a=0&ch=0&cr=0&dr=0&lr=unwatermarked&net=5&cd=0%7C0%7C0%7C0&cv=1&br=876&bt=876&cs=0&ds=4&ft=k7Fz7VVywIiRZm8Zmo~6RXMkWApJurrZvrKgb-Wmto0g3cI&mime_type=video_mp4&qs=0&rc=aWg5ZjY4ZjM6ZTg2PGhlZ0BpM2k3c3A5cjh4djMzNGkzM0AzL19jYjFjNjAxYy0vMzZhYSNyNjIwMmRrZnJgLS1kLWFzcw%3D%3D&btag=80000e00010000&dy_q=1732873193&feature_id=46a7bb47b4fd1280f3d3825bf2b29388&l=202411291739535F2F85525DC00016BB88\",\"cover\":\"https:\\/\\/p3-pc-sign.douyinpic.com\\/image-cut-tos-priv\\/4f31ff17cae169dbc5706cfc9d98257c~tplv-dy-resize-origshort-autoq-75:330.jpeg?x-expires=2048230800&x-signature=qbRi7izXjkqKS3Iz7tkek7v9NWM%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=cover&biz_tag=pcweb_cover&l=202411291739536543C9A16375B3048060\",\"bigFile\":false,\"down\":\"https:\\/\\/v26-default.365yg.com\\/d01a8f8a6f30ed0aef6b43242492b361\\/67499a14\\/video\\/tos\\/cn\\/tos-cn-ve-15\\/o4eEQQefAAFhIkH8Z2ippziTe73YIBPveUEvCf\\/?a=0&ch=0&cr=0&dr=0&lr=unwatermarked&net=5&cd=0%7C0%7C0%7C0&cv=1&br=876&bt=876&cs=0&ds=4&ft=k7Fz7VVywIiRZm8Zmo~6RXMkWApJurrZvrKgb-Wmto0g3cI&mime_type=video_mp4&qs=0&rc=aWg5ZjY4ZjM6ZTg2PGhlZ0BpM2k3c3A5cjh4djMzNGkzM0AzL19jYjFjNjAxYy0vMzZhYSNyNjIwMmRrZnJgLS1kLWFzcw%3D%3D&btag=80000e00010000&dy_q=1732873193&feature_id=46a7bb47b4fd1280f3d3825bf2b29388&l=202411291739535F2F85525DC00016BB88\",\"download_image\":\"https:\\/\\/p3-pc-sign.douyinpic.com\\/image-cut-tos-priv\\/4f31ff17cae169dbc5706cfc9d98257c~tplv-dy-resize-origshort-autoq-75:330.jpeg?x-expires=2048230800&x-signature=qbRi7izXjkqKS3Iz7tkek7v9NWM%3D&from=327834062&s=PackSourceEnum_AWEME_DETAIL&se=false&sc=cover&biz_tag=pcweb_cover&l=202411291739536543C9A16375B3048060\"}}")
      
      const { url, loading } = this
      if (loading || !url) {
        return
      }
      this.loading = true
      var urlRes = await this.handleGetDouYinMasterUrl(url)
      if (urlRes.error != 0) {
        this.loading = false
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: urlRes.info,
          confirmButtonText: '确定',
        })
        return
      }
      const resUrl = urlRes.info
      var res = await this.$API.tsy.post({
        Url: resUrl
      })
      this.loading = false
      const data = JSON.parse(res.info)
      this.selectedList = []
      if (data.code == 200) {
        const list = data.data.pics || data.data.images || []
        const videoImg = data.data.cover
        const videoUrl = data.data.down
        this.assetsData = {
          all: false,
          list,
          videoImg,
          videoUrl,
          title: data.data.title
        }
      } else {
        this.assetsData = {
          all: false,
          list: [],
          videoImg: '',
          videoUrl: '',
          title: ''
        }
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: data.msg,
          confirmButtonText: '确定',
        })
      }
    },
  }
};
</script>

<style lang="less" scoped>
.page-title {
  padding: 30px 0 22px;
  line-height: 48px;
  font-size: 32px;
  font-weight: bold;
  color: #3d3d42;
}
.content-item {
  margin-bottom: 30px;
  width: 100%;
  height: 874px;
  display: flex;
  align-items: stretch;
  border-radius: 8px;
  background-color: #f5f5f5;
  .left-item {
    width: 340px;
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    .textarea {
      height: 216px;
      padding: 12px 16px;
      border: 1px solid #ccc;
      border-radius: 8px;
      background-color: #f5f5f5;
      textarea {
        font-size: 14px;
        line-height: 21px;
      }
    }
    .btn {
      cursor: pointer;
      width: 100%;
      height: 45px;
      text-align: center;
      line-height: 45px;
      border-radius: 6px;
      margin-top: 30px;
      background-color: #6a5ffe;
      color: #fff;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .right-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .empty {
      width: 420px;
      height: 420px;
    }
    .assets-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .btn-item {
        width: 100%;
        height: 80px;
        border-radius: 0 8px 8px 0;
        background-color: #fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .btn {
          cursor: pointer;
          padding: 0 30px;
          height: 44px;
          border-radius: 6px;
          background-color: #6a5ffe;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-weight: bold;
          margin-right: 20px;
          &:nth-last-child(1) {
            margin-right: 30px;
          }
          img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
          }
        }
      }
      .video-item {
        flex: 1;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .img {
          width: 960px;
          height: 540px;
        }
      }
      .img-list-item  {
        flex: 1;
        padding: 30px;
        overflow-y: auto;
        .img-item {
          position: relative;
          float: left;
          margin-right: 30px;
          margin-bottom: 30px;
          width: 220px;
          height: 320px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            transform: translateY(-10px);
            .inner-btn-item {
              display: flex;
            }
          }
          .inner-btn-item {
            position: absolute;
            bottom: 12px;
            left: 12px;
            right: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btn {
              cursor: pointer;
              height: 40px;
              padding: 0 14px;
              background-color: rgba(0, 0, 0, .6);
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 14px;
              color: #fff;
              font-weight: bold;
              white-space: nowrap;
              img {
                width: 20px;
                height: 20px;
                margin-right: 6px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
